export enum SecurityRights {
    Admin = 2,
}

export enum HttpResponseStatus {
    Unauthorized = 401
}
